export * from '@zxing/ngx-scanner'
